module.exports = __webpack_public_path__ + "static/img/icon_94_jingyanno.17082795.png";